import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Input } from 'components/inputs'
import { Select } from 'components/select'
import { AddItemButton } from 'components/buttons'
import { dialogTypes } from 'dialogs'
import { holdingStrategy } from 'enums/holdingStrategy'
import { bottleVolume } from 'enums/bottleVolume'
import { loweIndex } from 'enums/loweIndex'
import { Dropzone } from 'components/dropzone'
import { api as producersApi } from 'store/modules/lookups/producers'
import { api as wineStylesApi } from 'store/modules/lookups/wineStyles'
import { api as wineTypesApi } from 'store/modules/lookups/wineTypes'
import { api as grapesApi } from 'store/modules/lookups/grapes'
import { api as countriesApi } from 'store/modules/lookups/countries'
import { api as regionsApi } from 'store/modules/lookups/regions'
import { api as districtsApi } from 'store/modules/lookups/districts'
import { api as subdistrictsApi } from 'store/modules/lookups/subdistricts'
import { api as classificationByOriginApi } from 'store/modules/lookups/classificationByOrigins'
import { api as classificationByParamsApi } from 'store/modules/lookups/classificationByParamses'
import { Images } from 'components/images'
import { WineEvaluations } from './wineEvaluations'
import { WsetEvaluations } from './wsetEvaluations'

const Form = (props) => {
  const { disabled, data, updateEntity, localize, isInDialog } = props
  const { entity } = data
  if (!entity) { return null }

  return (
    <RsForm>
      <Row>
        <Col sm={5}>
          <Label>{localize('common.name')}</Label>
          <Validator name='name' value={entity.name} required maxLength={255} disabled={disabled}>
            <Input value={entity.name} onChange={updateEntity('name')} placeholder={localize('common.name')} disabled={disabled} />
          </Validator>
        </Col>
        <Col sm={3}>
          <Label>{localize('wines.vintage')}</Label>
          <Validator name='vintage' value={entity.vintage} min={1800} max={2100} disabled={disabled}>
            <Input value={entity.vintage} isNumeric onChange={updateEntity('vintage')}
              placeholder={localize('wines.vintage')} disabled={disabled}
              />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.producer')}</Label>
          <AddItemButton dialogType={dialogTypes.producerDetail} disabled={disabled} onCreatedEntity={updateEntity('producer')}>
            <Validator name='producer' value={entity.producer} required disabled={disabled}>
              <Select
                dataSource={producersApi.get}
                value={entity.producer}
                onChange={updateEntity('producer')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
      </Row>
      <Row><Col><hr /></Col></Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('wines.wineStyle')}</Label>
          <AddItemButton dialogType={dialogTypes.wineStyleDetail} disabled={disabled} onCreatedEntity={updateEntity('wineStyle')}>
            <Validator name='wineStyle' value={entity.wineStyle} required disabled={disabled}>
              <Select
                dataSource={wineStylesApi.get}
                value={entity.wineStyle}
                onChange={updateEntity('wineStyle')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.wineType')}</Label>
          <AddItemButton dialogType={dialogTypes.wineTypeDetail} disabled={disabled} onCreatedEntity={updateEntity('wineType')}>
            <Validator name='wineType' value={entity.wineType} disabled={disabled}>
              <Select
                dataSource={wineTypesApi.get}
                value={entity.wineType}
                nullable
                onChange={updateEntity('wineType')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.grape')}</Label>
          <AddItemButton dialogType={dialogTypes.grapeDetail} disabled={disabled} onCreatedEntity={updateEntity('grape')}>
            <Validator name='grape' value={entity.grape} disabled={disabled}>
              <Select
                dataSource={grapesApi.get}
                value={entity.grape}
                onChange={updateEntity('grape')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        
      </Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('wines.country')}</Label>
          <AddItemButton dialogType={dialogTypes.countryDetail} disabled={disabled} onCreatedEntity={updateEntity('country')}>
            <Validator name='country' value={entity.country} disabled={disabled}>
              <Select
                dataSource={countriesApi.get}
                value={entity.country}
                onChange={updateEntity('country')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.region')}</Label>
          <AddItemButton dialogType={dialogTypes.regionDetail} disabled={disabled} onCreatedEntity={updateEntity('region')}>
            <Validator name='region' value={entity.region} required disabled={disabled}>
              <Select
                dataSource={regionsApi.get}
                value={entity.region}
                onChange={updateEntity('region')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.district')}</Label>
          <AddItemButton dialogType={dialogTypes.districtDetail} disabled={disabled} onCreatedEntity={updateEntity('district')}>
            <Validator name='district' value={entity.district} disabled={disabled}>
              <Select
                dataSource={districtsApi.get}
                value={entity.district}
                onChange={updateEntity('district')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        
      </Row>
      
      <Row>
        <Col sm={4}>
          <Label>{localize('wines.subdistrict')}</Label>
          <AddItemButton dialogType={dialogTypes.subdistrictDetail} disabled={disabled} onCreatedEntity={updateEntity('subdistrict')}>
            <Validator name='subdistrict' value={entity.subdistrict} disabled={disabled}>
              <Select
                dataSource={subdistrictsApi.get}
                value={entity.subdistrict}
                onChange={updateEntity('subdistrict')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('bottles.holdingStrategy')}</Label>
          <Select value={entity.holdingStrategy} onChange={updateEntity('holdingStrategy')}
              placeholder={localize('bottles.holdingStrategy')} disabled={disabled}
              enum={holdingStrategy} />
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.bottleVolume')}</Label>
          <Select value={entity.bottleVolume} onChange={updateEntity('bottleVolume')}
              placeholder={localize('bottles.bottleVolume')} disabled={disabled}
              enum={bottleVolume} />
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('wines.additionalGrape1')}</Label>
          <AddItemButton dialogType={dialogTypes.grapeDetail} disabled={disabled} onCreatedEntity={updateEntity('additionalGrape1')}>
            <Validator name='additionalGrape1' value={entity.additionalGrape1} disabled={disabled}>
              <Select
                dataSource={grapesApi.get}
                value={entity.additionalGrape1}
                onChange={updateEntity('additionalGrape1')}
                nullable
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.additionalGrape2')}</Label>
          <AddItemButton dialogType={dialogTypes.grapeDetail} disabled={disabled} onCreatedEntity={updateEntity('additionalGrape2')}>
            <Validator name='additionalGrape2' value={entity.additionalGrape2} disabled={disabled}>
              <Select
                dataSource={grapesApi.get}
                value={entity.additionalGrape2}
                onChange={updateEntity('additionalGrape2')}
                nullable
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.additionalGrape3')}</Label>
          <AddItemButton dialogType={dialogTypes.grapeDetail} disabled={disabled} onCreatedEntity={updateEntity('additionalGrape3')}>
            <Validator name='additionalGrape3' value={entity.additionalGrape3} disabled={disabled}>
              <Select
                dataSource={grapesApi.get}
                value={entity.additionalGrape3}
                onChange={updateEntity('additionalGrape3')}
                nullable
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('bottles.expiration')}</Label>
          <Validator name='expiration' value={entity.expiration} disabled={disabled} min={1800} max={2200}>
            <Input isNumeric disabled={disabled} value={entity.expiration} onChange={updateEntity('expiration')} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('bottles.expQuality')}</Label>
          <Validator name='expQuality' value={entity.expQuality} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.expQuality} onChange={updateEntity('expQuality')} />
          </Validator>
        </Col>
        
      </Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('wines.classificationByOrigin')}</Label>
          <AddItemButton dialogType={dialogTypes.classificationByOriginDetail} disabled={disabled} onCreatedEntity={updateEntity('classificationByOrigin')}>
            <Validator name='classificationByOrigin' value={entity.classificationByOrigin} disabled={disabled}>
              <Select
                dataSource={classificationByOriginApi.get}
                value={entity.classificationByOrigin}
                onChange={updateEntity('classificationByOrigin')}
                nullable
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.classificationByParams')}</Label>
          <AddItemButton dialogType={dialogTypes.classificationByParamsDetail} disabled={disabled} onCreatedEntity={updateEntity('classificationByParams')}>
            <Validator name='classificationByParams' value={entity.classificationByParams} disabled={disabled}>
              <Select
                dataSource={classificationByParamsApi.get}
                value={entity.classificationByParams}
                onChange={updateEntity('classificationByParams')}
                nullable
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('wines.alcohol')}</Label>
          <Validator name='alcohol' value={entity.alcohol} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.alcohol} onChange={updateEntity('alcohol')} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.acidity')}</Label>
          <Validator name='acidity' value={entity.acidity} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.acidity} onChange={updateEntity('acidity')} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('wines.sugar')}</Label>
          <Validator name='sugar' value={entity.sugar} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.sugar} onChange={updateEntity('sugar')} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>{localize('bottles.description')}</Label>
          <Validator name='description' value={entity.description} disabled={disabled} maxLength={1024}>

            <Input type={'textarea'} rows={5} disabled={disabled} value={entity.description || ''} onChange={updateEntity('description')} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Label>{localize('bottles.loweIndex')}</Label>
          <Select value={entity.loweIndex} onChange={updateEntity('loweIndex')}
              placeholder={localize('bottles.loweIndex')} disabled={disabled}
              enum={loweIndex} />
        </Col>
        <Col sm={4}>
          <Label>{localize('bottles.temperature')}</Label>
          <Validator name='temperature' value={entity.temperature} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.temperature} onChange={updateEntity('temperature')} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('bottles.customerRating')}</Label>
          <Validator name='customerRating' value={entity.customerRating} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.customerRating} onChange={updateEntity('customerRating')} />
          </Validator>
        </Col>
      </Row>
      <WineEvaluations entity={entity} localize={localize} updateEntity={updateEntity} disabled={disabled} isInDialog={isInDialog} />
      {/* <Row>
        <Col sm={4}>
          <Label>{localize('bottles.externalRating1')}</Label>
          <Validator name='externalRating1' value={entity.externalRating1} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.externalRating1} onChange={updateEntity('externalRating1')} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('bottles.externalRating2')}</Label>
          <Validator name='externalRating2' value={entity.externalRating2} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.externalRating2} onChange={updateEntity('externalRating2')} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('bottles.externalRating3')}</Label>
          <Validator name='externalRating3' value={entity.externalRating3} disabled={disabled}>
            <Input isNumeric disabled={disabled} value={entity.externalRating3} onChange={updateEntity('externalRating3')} />
          </Validator>
        </Col>
      </Row> */}
      <WsetEvaluations entity={entity} localize={localize} updateEntity={updateEntity} disabled={disabled} isInDialog={isInDialog} />
      <Row>
        <Col sm={12}>
          <Label>{localize('wines.comment')}</Label>
          <Validator name='comment' value={entity.comment} disabled={disabled}>
            <Input type={'textarea'} rows={5} value={entity.comment || ''} onChange={updateEntity('comment')} placeholder={localize('wines.comment')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row><Col><hr /></Col></Row>
      <Row><Col><Images imageIds={entity.imageIds} disabled={disabled} onImageRemove={id => updateEntity('imageIds')(entity.imageIds.filter(x => x !== id))} /></Col></Row>
      {!disabled && <Row>
        <Col>
          <Dropzone disabled={disabled}  onFileUploaded={id => updateEntity('imageIds')([ ...entity.imageIds, id])} />
        </Col>
      </Row>}
    </RsForm>
  )
}

export default Form